import { render, staticRenderFns } from "./StudentVariantView.vue?vue&type=template&id=006d648c&"
import script from "./StudentVariantView.vue?vue&type=script&lang=js&"
export * from "./StudentVariantView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports